export default "__VITE_ASSET__DtUZ$zQB__"